import { Dispatch, FC, SetStateAction, useContext } from 'react'
import './ToolbarDownloadFilename.scss'
import { AudioFileExtension } from '../../enums/AudioFileExtension'
import { getBaseFilename } from '../../functions/getBaseFilename'
import { CutterContext } from '../contexts/CutterContext'

interface Props {
  value: string
  setValue: Dispatch<SetStateAction<string>>
  extension: AudioFileExtension
  onBlur: Dispatch<string>
}

export const ToolbarDownloadFilename: FC<Props> = ({ value, setValue, onBlur, extension }) => {
  const { filename } = useContext(CutterContext)

  return (
    <div className="ToolbarDownloadFilename">
      <textarea
        className="value -textarea"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onBlur={() => {
          if (value) {
            onBlur(value)
          } else {
            const initial = getBaseFilename(filename)

            setValue(initial)
            onBlur(initial)
          }
        }}
      />

      <div className="value">
        <span className="text">{value}</span>
        <span className="ext">.{extension}</span>
      </div>
    </div>
  )
}
